var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('h2',[_vm._v("Search and add a pin")]),_c('label',[_c('gmap-autocomplete',{on:{"place_changed":_vm.setPlace}})],1),_c('br')]),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }